module.exports = __webpack_public_path__ + "img/ysgj_010@2x.b73daa10.png";